import styled from "styled-components";

export const TextInput = styled.div`
    padding: 15px 10px 5px 0;
    display: flex;
    align-items: baseline;
    width: 100%;
    height: 40px;
    border: ${(props) =>
        `1px solid ${
            props.focused
                ? props.invalidInput
                    ? props.theme.colors.error[700]
                    : props.theme.colors.secondary[700]
                : props.theme.colors.breathing
        }`};
    border-radius: 6px;
    cursor: pointer;
    outline: ${(props) => props.focused && "none"};

    .filter__y-scroll-anchor {
        position: absolute;
        top: -8px;
        left: 0;
    }
`;
